import { useEffect, useState } from "react";
import axios from "axios";
import { StarGlyph } from "./Reveal";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function StatsStrip() {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    let alive = true;
    const load = async () => {
      try {
        const { data } = await axios.get(`${API}/stats`);
        if (alive) setStats(data);
      } catch {
        /* strip stays hidden until stats load */
      }
    };
    load();
    const t = setInterval(load, 15000);
    return () => {
      alive = false;
      clearInterval(t);
    };
  }, []);

  if (!stats) return null;

  return (
    <div
      data-testid="stats-strip"
      className="flex items-center justify-center gap-4 border-b border-ink/10 bg-cream px-6 py-4 font-mono text-[10px] tracking-[0.3em] text-ink/60"
    >
      <span className="relative flex h-2 w-2">
        <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-blush opacity-60" />
        <span className="relative inline-flex h-2 w-2 rounded-full bg-blush" />
      </span>
      <span>LIVE FROM THE AURA</span>
      <StarGlyph className="h-2.5 w-2.5" fill="#FF8A3D" />
      <span>
        <span data-testid="stats-spins-count" className="font-bold text-ink">{stats.spins}</span> COMPASSES SPUN
      </span>
      <StarGlyph className="h-2.5 w-2.5" fill="#FF2E9E" />
      <span>
        <span data-testid="stats-codes-count" className="font-bold text-ink">{stats.codes}</span> CODES CLAIMED
      </span>
    </div>
  );
}
